<template>
    <Content class="col-span-full" :title="$route.name" :router="{
        name: 'VEHICLE_LIST',
    }">
        <el-form status-icon :model="ruleForm" :rules="rules" label-position="top" ref="ruleForm" label-width="120px"
            class="carpo-form demo-ruleForm">
            <el-form-item :label="$t('VEHCILE_NAME')" prop="vehicle.id" v-loading="vehicleLoading"
                element-loading-spinner="el-icon-loading">
                <el-select :disabled="ruleForm.disabled" :placeholder="$t('SELECT_PLACEHOLDER')"
                    v-model="ruleForm.vehicle.id" clearable filterable>
                    <el-option-group v-for="group in carList" :key="group.id"
                        :label="$i18n.locale == 'fa' ? group.fa_title : group.en_title">
                        <el-option v-for="item in group.vehicles" :key="item.id"
                            :label="$i18n.locale == 'fa' ? item.fa_title : item.en_title" :value="item.id">
                        </el-option>
                    </el-option-group>
                </el-select>
            </el-form-item>

            <LicensePlate :disabled="ruleForm.disabled" :license_plate_3="ruleForm.license_plate_3"
                @licensePlate3="ruleForm.license_plate_3 = $event" :license_plate_4="ruleForm.license_plate_4"
                @licensePlate4="ruleForm.license_plate_4 = $event" :license_plate_letter="ruleForm.license_plate_letter"
                @licensePlateLetter="ruleForm.license_plate_letter = $event" :license_plate_1="ruleForm.license_plate_1"
                @licensePlate1="ruleForm.license_plate_1 = $event" />

            <OrganizationalUnitSelect
                resource="vehicle"
                prop="organizational_unit"
                :model="ruleForm.organizational_unit"
                @update="ruleForm.organizational_unit = $event"
                :disabled="ruleForm.disabled"
            />

            <el-form-item class="col-span-full mt-8" :label="$t('description')" prop="description">
                <el-input :disabled="ruleForm.disabled" type="textarea" v-model="ruleForm.description"></el-input>
            </el-form-item>

            <FormConfirmation :loading="submitLoading" v-if="!ruleForm.disabled" @resetForm="resetForm('ruleForm')"
                @submitForm="submitForm('ruleForm')" :edit="null" />

        </el-form>
    </Content>
</template>
<script>
import { resetForm } from "@/mixins/resetForm";
import { addCar } from '@/api/cars';
import { carsList } from "@/api/global";
import FormConfirmation from '@/components/elements/formConfirmation.vue';
import LicensePlate from '@/components/elements/LicensePlate'
import OrganizationalUnitSelect from '@/components/elements/OrganizationalUnitSelect.vue'

export default {
    mixins: [resetForm],
    components: {
        FormConfirmation,
        LicensePlate,
        OrganizationalUnitSelect,
    },
    data() {
        return {
            carList: [],
            vehicleLoading: true,
            submitLoading: false,

            ruleForm: {
                description: "",
                organizational_unit: null,
                vehicle: {
                    id: ''
                },
                license_plate_4: '',
                license_plate_3: '',
                license_plate_1: '',
                license_plate_letter: ''
            },
            rules: {
                vehicle: {
                    id: [
                        {
                            required: true,
                            message: this.$i18n.t("REQUIRED_FIELD", {
                                type: this.$i18n.t("VEHCILE_NAME"),
                            }),
                            trigger: "change",
                        },
                    ]
                },
                license_plate_4: [
                    {
                        required: true,
                        trigger: "blur",
                        message: " ",
                    },
                ],
                license_plate_3: [
                    {
                        required: true,
                        trigger: "blur",
                        message: " ",
                    },
                ],
                license_plate_1: [
                    {
                        required: true,
                        trigger: "blur",
                        message: " ",
                    },
                ],
                license_plate_letter: [
                    {
                        required: true,
                        trigger: "blur",
                        message: " ",
                    },
                ],

            },
        };
    },

    methods: {
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    const actionPayload = {
                        vehicle: this.ruleForm.vehicle.id,
                        description: this.ruleForm.description,
                        organizational_unit: this.ruleForm.organizational_unit,
                        license_plate: this.ruleForm.license_plate_1 + this.ruleForm.license_plate_letter + this.ruleForm.license_plate_3 + this.ruleForm.license_plate_4,
                    };
                    this.submitLoading = true;
                    addCar.api(actionPayload).then(res => {
                        this.submitLoading = false;
                        if (res) {
                            this.$notify.success({
                                title: this.$t(this.$route.name) + " " + this.$t('SUCCESSFULLY_DONE'),
                                duration: 5000,
                                customClass: 'succ_msg'
                            });
                            this.resetForm(formName);
                        }
                    })
                } else {
                    this.$notify.error({
                        title: this.$i18n.t("FIXED_ERRORS", {
                            type: this.$i18n.t(this.$route.name)
                        }),
                        duration: 5000,
                        customClass: 'error_msg'
                    });
                    return false;
                }
            });
        },
    },
    created() {
        carsList.api().then((res) => {
            if (res) {
                this.vehicleLoading = false;
                this.carList = res;
            }
        });

    },
};
</script>
